import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {connectOnlineChat} from 'modules/online-chat/thunks';
import {useEffect} from 'react';

export const useOnlineChatConnect = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(connectOnlineChat());
    }, [dispatch]);
};
